import { AxiosError } from "axios";
import { PaginateResult } from "core/resources/types/shared";
import { useInfiniteQuery } from "react-query";
import { ManutencaoDto, ListarManutencaoQuery } from "../typings";
import http from "infra/http";

export function useListarManutencoesInfiniteQuery(
  query: ListarManutencaoQuery,
  enabled: boolean = true
) {
  return useInfiniteQuery<PaginateResult<ManutencaoDto>, AxiosError>(
    [`/v1/manutencao`, query, enabled],
    async ({ pageParam = 1 }) => {
      const { data } = await http.get<PaginateResult<ManutencaoDto>>(
        "/v1/manutencao",
        { params: { ...query, page: pageParam } }
      );

      return data;
    },
    {
      enabled: !!query.dataInicio && !!query.dataFim,
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}
